import { render, staticRenderFns } from "./messageCenter.vue?vue&type=template&id=28a34f70&scoped=true"
import script from "./messageCenter.vue?vue&type=script&lang=js"
export * from "./messageCenter.vue?vue&type=script&lang=js"
import style0 from "./messageCenter.vue?vue&type=style&index=0&id=28a34f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a34f70",
  null
  
)

export default component.exports